import { FormGroup, UntypedFormControl, UntypedFormGroup } from '@angular/forms';

export function validate(formGroup: UntypedFormGroup) {
  Object.keys(formGroup.controls).forEach((field) => {
    const control = formGroup.get(field);
    if (control instanceof UntypedFormControl) {
      control.markAsTouched({ onlySelf: true });
      control.updateValueAndValidity();
    } else if (control instanceof UntypedFormGroup) {
      this.validate(control);
    }
  });

  return formGroup.valid;
}

export function validateForm(formGroup: FormGroup) {
  Object.keys(formGroup.controls).forEach((field) => {
    const control = formGroup.get(field);
    if (control instanceof FormGroup) {
      control.markAsTouched({ onlySelf: true });
      control.updateValueAndValidity();
    } else if (control instanceof FormGroup) {
      this.validateForm(control);
    }
  });

  return formGroup.valid;
}
